import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.weak-map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import { SparseMatrix } from 'mathjs';
import { appendColumns, getColumn } from 'utils/ExpressionMatrix/sparseMatrixOperations';
import SparseMap from 'utils/SparseMap';
var _generateIndexFor = /*#__PURE__*/new WeakMap();
var _getExpression = /*#__PURE__*/new WeakMap();
var _getDensifiedExpression = /*#__PURE__*/new WeakMap();
var _getExpressionSparse = /*#__PURE__*/new WeakMap();
var ExpressionMatrix = /*#__PURE__*/function () {
  function ExpressionMatrix() {
    var _this = this;
    _classCallCheck(this, ExpressionMatrix);
    _defineProperty(this, "setGeneExpression", function (orderedNewGeneSymbols, newRawGeneExpression, newTruncatedGeneExpression, newZScore, newStats) {
      _this.rawGeneExpressions = newRawGeneExpression;
      _this.truncatedGeneExpressions = newTruncatedGeneExpression;
      _this.zScore = newZScore;
      _this.stats = newStats;
      _this.geneIndexes = orderedNewGeneSymbols.reduce(function (acum, currentSymbol, index) {
        // eslint-disable-next-line no-param-reassign
        acum[currentSymbol] = index;
        return acum;
      }, {});
    });
    /**
     * Generates a new index for the geneSymbol
     *
     * @param {*} geneSymbol The symbol of the gene
     * @returns The index of the gene inside the matrices
     */
    _classPrivateFieldInitSpec(this, _generateIndexFor, {
      writable: true,
      value: function value(geneSymbol) {
        var lastFreeIndex = Object.keys(_this.geneIndexes).length;
        _this.geneIndexes[geneSymbol] = lastFreeIndex;
        return lastFreeIndex;
      }
    });
    _classPrivateFieldInitSpec(this, _getExpression, {
      writable: true,
      value: function value(geneSymbol, cellIndexes, matrix) {
        var geneIndex = _this.geneIndexes[geneSymbol];
        if (_isNil(geneIndex)) return undefined;
        if ((cellIndexes === null || cellIndexes === void 0 ? void 0 : cellIndexes.length) === 0) return [];
        var result = getColumn(geneIndex, matrix, cellIndexes);
        return result;
      }
    });
    _classPrivateFieldInitSpec(this, _getDensifiedExpression, {
      writable: true,
      value: function value(geneSymbol, cellIndexes, matrix) {
        var result = _classPrivateFieldGet(_this, _getExpression).call(_this, geneSymbol, cellIndexes, matrix);

        // If it's a single number wrap in an array
        if (typeof result === 'number') return [result];
        if (_isNil(result) || _isEmpty(result)) return result;

        // If its a matrix transform it to an array
        return result.valueOf().flat();
      }
    });
    _classPrivateFieldInitSpec(this, _getExpressionSparse, {
      writable: true,
      value: function value(geneSymbol, cellIndexes, matrix, keyAsString) {
        var result = _classPrivateFieldGet(_this, _getExpression).call(_this, geneSymbol, cellIndexes, matrix);
        if (_isNil(result) || _isEmpty(result)) return new SparseMap([]);

        // If it's a single number just return a simple Map
        if (typeof result === 'number') return new SparseMap([[cellIndexes[0], result]]);
        return new SparseMap(result, cellIndexes, keyAsString);
      }
    });
    this.geneIndexes = {};
    this.rawGeneExpressions = new SparseMatrix();
    this.truncatedGeneExpressions = new SparseMatrix();
    this.zScore = new SparseMatrix();
    this.stats = {
      rawMean: [],
      rawStdev: [],
      truncatedMin: [],
      truncatedMax: []
    };
  }
  _createClass(ExpressionMatrix, [{
    key: "getRawExpression",
    value: function getRawExpression(geneSymbol) {
      var cellIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return _classPrivateFieldGet(this, _getDensifiedExpression).call(this, geneSymbol, cellIndexes, this.rawGeneExpressions);
    }
  }, {
    key: "getTruncatedExpression",
    value: function getTruncatedExpression(geneSymbol) {
      var cellIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return _classPrivateFieldGet(this, _getDensifiedExpression).call(this, geneSymbol, cellIndexes, this.truncatedGeneExpressions);
    }
  }, {
    key: "getZScore",
    value: function getZScore(geneSymbol) {
      var cellIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return _classPrivateFieldGet(this, _getDensifiedExpression).call(this, geneSymbol, cellIndexes, this.zScore);
    }
  }, {
    key: "getRawExpressionSparse",
    value: function getRawExpressionSparse(geneSymbol, cellIndexes) {
      var keyAsString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return _classPrivateFieldGet(this, _getExpressionSparse).call(this, geneSymbol, cellIndexes, this.rawGeneExpressions, keyAsString);
    }
  }, {
    key: "getTruncatedExpressionSparse",
    value: function getTruncatedExpressionSparse(geneSymbol, cellIndexes) {
      var keyAsString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return _classPrivateFieldGet(this, _getExpressionSparse).call(this, geneSymbol, cellIndexes, this.truncatedGeneExpressions, keyAsString);
    }
  }, {
    key: "getZScoreSparse",
    value: function getZScoreSparse(geneSymbol, cellIndexes) {
      var keyAsString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return _classPrivateFieldGet(this, _getExpressionSparse).call(this, geneSymbol, cellIndexes, this.zScore, keyAsString);
    }
  }, {
    key: "getStats",
    value: function getStats(geneSymbol) {
      var geneIndex = this.geneIndexes[geneSymbol];
      if (_isNil(geneIndex)) return undefined;
      return {
        rawMean: this.stats.rawMean[geneIndex],
        rawStdev: this.stats.rawStdev[geneIndex],
        truncatedMin: this.stats.truncatedMin[geneIndex],
        truncatedMax: this.stats.truncatedMax[geneIndex]
      };
    }
  }, {
    key: "geneIsLoaded",
    value: function geneIsLoaded(geneSymbol) {
      return !_isNil(this.geneIndexes[geneSymbol]);
    }
  }, {
    key: "genesAreLoaded",
    value: function genesAreLoaded(geneSymbols) {
      var _this2 = this;
      return geneSymbols.every(function (geneSymbol) {
        return _this2.geneIsLoaded(geneSymbol);
      });
    }
  }, {
    key: "getStoredGenes",
    value: function getStoredGenes() {
      return Object.keys(this.geneIndexes);
    }

    /**
     *
     * @param {*} orderedNewGeneSymbols A row with the gene symbols corresponding
     * to each row in the geneExpressions (in the same order)
     * @param {*} newRawGeneExpression A mathjs SparseMatrix with the
     *  raw gene expressions for each of the genes
     * @param {*} newTruncatedGeneExpression A mathjs SparseMatrix with the
     *  raw gene expressions for each of the genes
     * @param {*} newZScore A mathjs SparseMatrix with the
     *  zScore values for each of the genes
     * @param {*} newStats An object which with the stats for each gene's expression
     * Each key is a gene symbol,
     * Each value has this shape: {rawMean, rawStdev, truncatedMin, truncatedMax}
     */
  }, {
    key: "pushGeneExpression",
    value: function pushGeneExpression(orderedNewGeneSymbols, newRawGeneExpression, newTruncatedGeneExpression, newZScore, newStats) {
      var _this3 = this;
      var _this$rawGeneExpressi = this.rawGeneExpressions.size(),
        _this$rawGeneExpressi2 = _slicedToArray(_this$rawGeneExpressi, 2),
        genesCount = _this$rawGeneExpressi2[1];

      // If the matrix was empty previously we can just replace it with the ones that are being pushed
      if (genesCount === 0) {
        this.setGeneExpression(orderedNewGeneSymbols, newRawGeneExpression, newTruncatedGeneExpression, newZScore, newStats);
        return;
      }
      var genesToAddIndexes = [];

      // Store indexes for the new genes
      orderedNewGeneSymbols.forEach(function (geneSymbol, index) {
        // Skip if gene is already loaded
        if (_this3.geneIsLoaded(geneSymbol)) return;
        genesToAddIndexes.push(index);
        _classPrivateFieldGet(_this3, _generateIndexFor).call(_this3, geneSymbol);
      });

      // Add the expression only for the new genes (genesToAddIndexes)
      appendColumns(this.rawGeneExpressions, newRawGeneExpression, genesToAddIndexes);
      appendColumns(this.truncatedGeneExpressions, newTruncatedGeneExpression, genesToAddIndexes);
      appendColumns(this.zScore, newZScore, genesToAddIndexes);

      // Add new stats only for the genes that were added
      genesToAddIndexes.forEach(function (index) {
        _this3.stats.rawMean.push(newStats.rawMean[index]);
        _this3.stats.rawStdev.push(newStats.rawStdev[index]);
        _this3.stats.truncatedMin.push(newStats.truncatedMin[index]);
        _this3.stats.truncatedMax.push(newStats.truncatedMax[index]);
      });
    }
  }]);
  return ExpressionMatrix;
}();
export default ExpressionMatrix;